export const API_EndPoints = {
    Users: {
        RegisterAdmin: "users/create_admin",
        RegisterUser: "users/create_user",
        AuthenticateUser: "users/authenticate_user",
        AuthenticateOTP: "users/authenticate_otp",
        SendOTP: "users/send_otp",
        SendSignupOTP: "users/send_signup_otp",
        ResendOTP: "users/resend_otp",
        UpdateUser: "users/update_data",
        changePassword: "users/change_password",
        updatePassword: "users/update_password",
        logoutUser:"users/logout"
    },
    General: {
        InsertData: "general/insert_data",
        UpdateData: "general/update_data",
        UpdateManyData: "general/update_data_many",
        DelteDataById: "general/delete_data_by_id",
        DeleteDataManyById: "general/delete_data_many",
        FetchData: "general/get_data",
        ContactUs:"contact/send_mail",
    },
    Report:{
        sendReport:"reports/send_report"
    },
    Custom: {
        getAnalytics: "custom/get_analytics",
        getYearlyReport: "custom/get-reports-by-year",
        getYearlyReportByType: "custom/get-reports-by-year-by-user-type"
    }
}